function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.985157mm",
    height: "5.9851532mm",
    viewBox: "0 0 3.985157 5.9851532",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60.666852,-96.596877)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 63.825447,99.048439 q 0.0078,-0.05469 0.01172,-0.121094 0.0039,-0.06641 0.0039,-0.199218 0,-0.714844 -0.296875,-1.078125 -0.292969,-0.367188 -0.871094,-0.367188 -0.558593,0 -0.882812,0.335938 -0.320313,0.332031 -0.320313,0.910156 0,0.542969 0.285157,0.832031 0.285156,0.289063 0.820312,0.289063 0.351563,0 0.660156,-0.148438 0.308594,-0.148437 0.589844,-0.453125 z m -0.04297,0.625 q -0.238281,0.269531 -0.601562,0.414061 -0.359375,0.14453 -0.789063,0.14453 -0.757812,0 -1.191406,-0.441403 -0.433594,-0.445313 -0.433594,-1.222657 0,-0.847656 0.53125,-1.359375 0.53125,-0.511718 1.421875,-0.511718 0.871094,0 1.351563,0.5625 0.480469,0.5625 0.480469,1.582031 0,1.003906 -0.386719,1.824222 -0.386719,0.82031 -1.09375,1.32812 -0.308594,0.22266 -0.671875,0.35547 -0.359375,0.13281 -0.632813,0.13281 -0.203125,0 -0.304687,-0.0859 -0.101563,-0.0859 -0.101563,-0.25782 0,-0.0508 0.04297,-0.22656 0.0078,-0.0312 0.01563,-0.0469 0.03906,0.008 0.08984,0.0117 0.05078,0.004 0.128906,0.004 0.746094,0 1.339844,-0.60547 0.597656,-0.60547 0.804687,-1.601561 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit9);
export default __webpack_public_path__ + "static/media/digit-9.4a8beb741c21e25384cc9d8a87bd601a.svg";
export { ForwardRef as ReactComponent };